import { getTextStyle, handleTooltipFormatting } from "../../utils";

export const verticalStacked = (
  props: { [key: string]: any } = {},
  data: { [key: string]: { [key: string]: any } | string[] } = {},
) => {
  const legendTextStyle = getTextStyle(props, "legend");
  const axisTextStyle = getTextStyle(props, "axis");
  const isMobile: boolean = window.innerWidth <= 768;
  const isLegend = props.showLegend && (data.series as unknown[]).length > 1;
  const overValidationChar: boolean = data.titles.some(
    (title: string) => title.length > 5,
  );
  let gridOptions: { [key: string]: number } = {};
  let legendOptions: Record<string, unknown> = {
    show: isLegend,
    type: "scroll",
    itemGap: 16,
    itemStyle:
      data.series.length === 1
        ? { color: "transparent", borderColor: props.color, borderWidth: 1 }
        : {},
    textStyle: legendTextStyle,
  };
  if (isLegend) {
    switch (props.legendPosition) {
      case "bottom":
        legendOptions = { ...legendOptions, bottom: 0 };
        gridOptions = { bottom: 48, top: 48, left: 10, right: 10 };
        break;
      case "top":
        legendOptions = { ...legendOptions, top: 0 };
        gridOptions = { bottom: 3, top: 48, left: 10, right: 10 };
        break;
    }
  } else {
    gridOptions = { top: 25, bottom: 3, right: 3, left: 10 };
  }

  return {
    xAxis: {
      type: "category",
      z: 10,
      data: data.titles || [],
      axisLabel: {
        hideOverlap: true,
        show: props.showAxisLabels,
        width: isMobile ? 50 : 100,
        interval: 0,
        overflow: "truncate",
        ...axisTextStyle,
        rotate: (props.axis?.rotate ?? overValidationChar) ? 45 : 0,
      },
      tooltip: {
        show: true,
        padding: 4,
      },
    },
    yAxis: {
      type: "value",
      boundaryGap: [0, 0],
      splitLine: {
        show: props.showGridlines,
        lineStyle: {
          color: props.darkMode ? "rgba(255, 255, 255, 0.15)" : "#E0E6F1",
        },
      },
      axisLabel: {
        hideOverlap: true,
        formatter: `${props.prefix || ""}{value}${props.suffix || ""}`,
        show: props.showAxisLabels,
        width: isMobile ? 50 : 100,
        overflow: "truncate",
        ...axisTextStyle,
      },
      tooltip: {
        show: true,
        padding: 4,
      },
    },
    tooltip: {
      formatter: (params: Record<string, string | number>) =>
        handleTooltipFormatting(params, props.prefix, props.suffix),
    },
    title: {
      show: false,
    },
    textStyle: {
      color: props.color,
      fontFamily: props.fontFamily,
    },
    series: data.series || [],
    legend: legendOptions,
    animation: props.animation,
    labelLayout: { hideOverlap: true },
    grid: { ...gridOptions, containLabel: true },
  };
};
